import React from 'react';
import { Helmet } from 'react-helmet';
import ChapterAudioPlayer from './ChapterAudioPlayer';
import booksData from './booksData';
import './BookLandingPage.css';

const pageUrl = 'https://jerryevanoff.com/books/networking-murder';
const coverImage = '/images/CoverBook3.jpg';
const pageDescription = 'Networking Murder by Jerry Evanoff is Book 3 in the Sam Norris Murder Mystery Series. Listen to an AI-generated reading of Chapter 1.';

const book = booksData.find((entry) => entry.title === 'Networking Murder');

const NetworkingMurder = () => (
  <section className="book-landing-page">
    <Helmet>
      <title>Networking Murder by Jerry Evanoff | Sam Norris Murder Mystery Book 3</title>
      <meta name="description" content={pageDescription} />
      <meta name="author" content="Jerry Evanoff" />
      <link rel="canonical" href={pageUrl} />

      <meta property="og:type" content="book" />
      <meta property="og:title" content="Networking Murder by Jerry Evanoff" />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={`https://jerryevanoff.com${coverImage}`} />
      <meta property="og:url" content={pageUrl} />
    </Helmet>

    <div className="book-landing-container">
      <div className="book-landing-main">
        <h1 className="book-landing-title">Networking Murder</h1>
        <h2 className="book-landing-subtitle">Book 3 in the Sam Norris Murder Mystery Series</h2>

        <div className="book-landing-hero">
          <div className="book-landing-cover-block">
            <img src={coverImage} alt="Networking Murder by Jerry Evanoff" className="book-landing-cover" />
          </div>

          {book && (
            <div className="book-landing-copy">
              <p>{book.description}</p>
            </div>
          )}
        </div>

        <ChapterAudioPlayer src="/audio/networking-murder-chapter-1.mp3" heading="Wanna hear an AI-generated Chapter 1?" />
      </div>
    </div>
  </section>
);

export default NetworkingMurder;
